(() => {
  const parse = value => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(value || '') ? Date.parse(value) : NaN;
  const remaining = (start, end, now) => {
    const from = start ? parse(start) : null, until = parse(end);
    if (!Number.isFinite(until) || now >= until) return null;
    if (start && (!Number.isFinite(from) || until <= from || now < from)) return null;
    const seconds = Math.ceil((until - now) / 1000);
    return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60];
  };
  // One scheduled rollover shared by every placement; never a daily reset.
  const countdownPeriod = (end, resetAt, now) => {
    const reset = parse(resetAt), finalEnd = parse(end);
    if (Number.isFinite(reset) && reset < finalEnd && now < reset) {
      return { end: resetAt, displayEnd: new Date(reset - 1000).toISOString() };
    }
    return { end, displayEnd: end };
  };
  if (typeof module !== 'undefined') module.exports = { remaining, countdownPeriod };
  if (typeof customElements === 'undefined' || customElements.get('teema-birthday-clock')) return;
  customElements.define('teema-birthday-clock', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.abort = new AbortController();
      const deadline = this.querySelector('[data-deadline]');
      const update = () => {
        const now = Date.now();
        const period = countdownPeriod(this.dataset.end, this.dataset.resetAt, now);
        if (deadline && Number.isFinite(Date.parse(period.displayEnd)) && deadline.getAttribute('datetime') !== period.displayEnd) {
          const date = new Date(period.displayEnd);
          const day = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric' }).format(date);
          const time = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: '2-digit' }).format(date);
          deadline.textContent = `Ends ${day} at ${time} PT`;
          deadline.setAttribute('datetime', period.displayEnd);
        }
        const values = this.dataset.preview === 'true' ? [24, 0, 0] : remaining(this.dataset.start, period.end, now);
        this.hidden = !values;
        if (!values) {
          clearInterval(this.timer);
          const end = parse(this.dataset.end);
          if (Number.isFinite(end) && now >= end) {
            document.querySelectorAll('[data-flash-nav-label]').forEach(node => { node.textContent = 'Shop Teema'; });
            const panel = this.closest('[data-flash-panel]');
            panel?.querySelectorAll('[data-flash-copy]').forEach(node => { node.hidden = true; });
            const ended = panel?.querySelector('[data-flash-ended]');
            if (ended) ended.hidden = false;
          }
          return;
        }
        ['hours', 'minutes', 'seconds'].forEach((part, i) => {
          const node = this.querySelector(`[data-${part}]`);
          if (node) node.textContent = String(values[i]).padStart(2, '0');
        });
        const spokenTime = values.map((value, i) => `${value} ${['hour', 'minute', 'second'][i]}${value === 1 ? '' : 's'}`).join(', ');
        this.querySelector('[role="timer"]')?.setAttribute('aria-label', `${spokenTime} remaining in the flash sale`);
      };
      update();
      if (!this.hidden && this.dataset.preview !== 'true') this.timer = setInterval(update, 1000);
      document.addEventListener('visibilitychange', update, { signal: this.abort.signal });
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
})();
